let perPage = 100
let filters = '.grid.product .grid__item'

$(document).ready(function(){
  $('.grid.product .grid__item').css('opacity',1)
  $('.toggle_menu').click(function(){
  $('.mobile_navigation').toggle(); 
  })
  $('.mobile_navigation .main-menu-item').each(function(){
  let subMenu = $(this).find('.submenu').length
  if(subMenu){
      $(this).addClass('submenu-wrap')
      $('<span class="mobile-toggle"></span>').insertBefore($(this).find('.submenu') );
  }
  })
  $(document).on('click','.mobile-toggle',function(){
    if($(this).hasClass('nav-subopen')){
  
        $(this).removeClass('nav-subopen');
        $(this).parents('.submenu-wrap').find('.submenu').slideUp();
    }
    else{
        $('.mobile-toggle').removeClass('nav-subopen');
        $(this).addClass('nav-subopen')
        $('.submenu-wrap .submenu').slideUp();
        $(this).parents('.submenu-wrap').find('.submenu').slideDown();
    }
  })


  $('.shop-streetwear-slider-main-wrap').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots:false,
    prevArrow: '<button class="slick-prev slick-arrow"><img src="https://cdn.shopify.com/s/files/1/0312/2131/7764/files/prev-arrow.png?v=1666957795"/></button>',
    nextArrow: '<button class="slick-next slick-arrow"><img src="https://cdn.shopify.com/s/files/1/0312/2131/7764/files/next-arrow.png?v=1666957794"/></button>'
  });

  $('.product-card-wrap .product-card__info').each(function(){
    const divHeight = $(this).height();
    $(this).parents('.product-card-wrap').find('.product-card__image-container').css("margin-bottom", divHeight+'px')
  })

  $(document).on('click','.ast-addon-quantity-wrapper .ast-quantity-plus',function(){
      // e.preventDefault();
    const mainQuantity = parseInt($('.product-form__item--quantity input').val());
    const addonQuantity = parseInt($(this).parent('.ast-quantity').find('input').val());
    if(addonQuantity+2 >mainQuantity*3){
      $(this).attr("disabled", true)
    }
  })

  $(document).on('click','.ast-addon-quantity-wrapper .ast-quantity-minus,.product-form__item--quantity button',function(){
     const mainQuantity = parseInt($('.product-form__item--quantity input').val());
    const addonQuantity = parseInt($('.ast-addon-quantity-wrapper input').val());

    if(addonQuantity <= mainQuantity*3){
      $('.ast-addon-quantity-wrapper .ast-quantity-plus').attr("disabled", false)
    }

   })

  $(document).on('click','.product-form__item--quantity .js-qty__adjust--minus',function(){
    const mainQuantity = parseInt($('.product-form__item--quantity input').val());
    const addonQuantity = parseInt($('.ast-addon-quantity-wrapper input').val());
    if(addonQuantity > mainQuantity*3){
      setTimeout(() => $('.ast-addon-quantity-wrapper .ast-quantity-minus').trigger("click"), 10);
      setTimeout(() => $('.ast-addon-quantity-wrapper .ast-quantity-minus').trigger("click"), 20);
      setTimeout(() => $('.ast-addon-quantity-wrapper .ast-quantity-minus').trigger("click"), 30);
    }

    
    
   })

  $(document).on('change','.cart-attribute__field select',function(){
    const dataValue = $(this).val()
    dataValue ? $('.cart_item-wrap .submit_btn').removeClass("disabled") : $('.cart_item-wrap .submit_btn').addClass("disabled") ;
  });
  
  $(document).on('click','.open-dorp-down label',function(){
    var divObj = $(this).next();
      var nstyle = divObj.css("display");
        if (nstyle == "none") {
          $(this).addClass('active-list');
          divObj.slideDown(false, function() {
            $('.open-dorp-down label').removeClass('active-list')
            $("html").bind("click", function() {
              divObj.slideUp();
              $("html").unbind("click");
              $('.open-dorp-down label').removeClass('active-list')
            });
          });
        }  
  });

  $(document).on('click','.grid__item #sortby-ref li',function(e){
    e.preventDefault();
    $('.grid__item #SortBy').val($(this).attr('data-value')).change()
  });

  let currentURL = window.location.href;

    // if(!currentURL.includes('/pages/')){
    //   let getSortVal = $('.grid__item #SortBy').val()
    //   let activeText =  $('.grid__item #sortby-ref li.active').text()
    //   $('#sortby-ref label').text(activeText)
        
      
    //   let activeTextFilter =  $('.grid__item #sorttag-ref li.active a').text()
    //   $('#sorttag-ref label').text(activeTextFilter?.length ? activeTextFilter : 'All Equipment')
    // }

  $(document).on("click", ".grid__item .limited-button", function () {
    const parent = $(this).closest(".collection-page-wrap"); // Get the closest parent collection-page-wrap
    const productGrid = parent.find(".grid.product"); // Find the product listing inside that parent
    let getOnOrOff = $(this).find('input[type="checkbox"]').is(":checked");

    applyFilters(parent);
    
    // if (getOnOrOff) {
    //     productGrid.find(".grid__item").hide();
    //     // filters = productGrid.find(".grid__item.limited-time"); // Scoped filtering
    //       filters = filters.filter(".limited-time");
    // } else {
    //     filters = productGrid.find(".grid__item"); // Show all items in the same parent
    // }

    // filters.show(); // Show the filtered items
    // pagination(filters, parent); // Call pagination for this specific parent
    // page(1, parent); // Reset pagination to page 1 within the scoped section
});


  $('.collection-page-wrap').each(function(){
    pagination(filters,$(this));
    page(1,$(this));
  })
    

    $(document).on('click', ".pagination_list li.number", function (e) {
      e.preventDefault();
      const parent = $(this).closest(".collection-page-wrap"); // Get the closest parent
  
      parent.find('.pagination_list li.number').removeClass('active');
      $(this).addClass('active');
  
      let pageNo = $(this).attr('data-page');
      let pageNo1 = parseInt(pageNo);
  
      parent.find('.pagination_list li.number').hide();
      $(this).show();
  
      $(this).prevAll('li.number').length == 0 ? $(this).nextAll(':lt(3)').show() : 
      $(this).prevAll('li.number').length == 1 ? $(this).nextAll(':lt(2)').show() : 
      $(this).nextAll(':lt(2)').show();
  
      $(this).nextAll('li.number').length == 0 ? $(this).prevAll(':lt(3)').show() : 
      $(this).nextAll('li.number').length == 1 ? $(this).prevAll(':lt(2)').show() : 
      $(this).prevAll(':lt(2)').show();
  
      $(window).trigger('resize');
  
      page(pageNo1, parent); // Pass parent to ensure pagination is scoped correctly
  
      pageNo1 > 1 ? parent.find('.pagination_list .left-angle').removeClass('disabled') : 
                     parent.find('.pagination_list .left-angle').addClass('disabled');
  
      let lastPage = parent.find('.pagination_list li.number:last').attr('data-page');
      pageNo1 !== parseInt(lastPage) ? parent.find('.pagination_list .right-angle').removeClass('disabled') : 
                                        parent.find('.pagination_list .right-angle').addClass('disabled');
  });
  
  $(document).on('click', '.pagination_list .right-angle', function (e) {
      e.preventDefault();
      const parent = $(this).closest(".collection-page-wrap"); // Get the closest parent
      $(window).trigger('resize');
      parent.find('.pagination_list li.number.active').next().trigger('click');
  });

  $(document).on('click', '.pagination_list .left-angle', function (e) {
      e.preventDefault();
      const parent = $(this).closest(".collection-page-wrap"); // Get the closest parent
      $(window).trigger('resize');
      parent.find('.pagination_list li.number.active').prev().trigger('click');
  });

/*
const replacements = {
  "QUICK SHIP": "In Stock",
  "Quick Ship": "In Stock",
  "quickship": "In Stock",
  "Quickship": "In Stock"
};
*/
  
// Run the replacement script
replaceKeywordsEverywhere(replacements);


  if($('.right-side-img-slider').length){
    $('.right-side-img-slider').slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      dots: true
    });
    $('.right-side-img-slider .slick-dots').wrapAll('<div class="custom-arrow"></div>');
    $('.right-side-img-slider .slick-prev').prependTo('.right-side-img-slider .custom-arrow');
    $('.right-side-img-slider .slick-next').appendTo('.right-side-img-slider .custom-arrow');
  }
  if($('.qsp-related-product-list-wrap').length){
    $('.qsp-related-product-list-wrap').slick({
      dots: false,
      infinite: false,
      speed: 300,
      slidesToShow: 4,
      slidesToScroll: 4,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: true,
            dots: false
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
             arrows: false,
            dots: true
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            arrows: false,
            dots: true
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: true
          }
        } 
      ]
    });
  }



  $(document).on("click", ".custom_filter ul li", function () {
    const checkData = $(this).attr("data-value");
    const parent = $(this).closest(".collection-page-wrap"); // Get closest parent container
    const productList = parent.find(".product-listing"); // Find the product listing inside that parent

    $(this).addClass("active").siblings().removeClass("active");
    parent.find("#sortby-ref label").text($(this).text());

    if (checkData === "title-ascending") {
        productList.find(".grid__item").sort(asc_sort_title).appendTo(productList);
    } else if (checkData === "title-descending") {
        productList.find(".grid__item").sort(dec_sort_title).appendTo(productList);
    } else if (checkData === "price-ascending") {
        productList.find(".grid__item").sort(asc_sort_price).appendTo(productList);
    } else if (checkData === "price-descending") {
        productList.find(".grid__item").sort(dec_sort_price).appendTo(productList);
    } else if (checkData === "created-ascending") {
        productList.find(".grid__item").sort(asc_sort_date).appendTo(productList);
    } else if (checkData === "created-descending") {
        productList.find(".grid__item").sort(dec_sort_date).appendTo(productList);
    } else {
        productList.find(".grid__item").sort(sort_default).appendTo(productList);
    }
    pagination(filters,parent);
    page(1,parent);
  });
 
  $(document).on("click", ".filter li a", function (e) {
    e.preventDefault();
    const checkData = $(this).parent().attr("data-value");
    const parent = $(this).closest(".collection-page-wrap");
     $(this).parent().addClass("active").siblings().removeClass("active");
    $(this).parents('.filter').find('label').text($(this).text())
    applyFilters(parent);
    // let filterQuery = ''
    //  if (checkData == "coming-soon") {
    //     
    //      filterQuery = '.coming_soon_product';
    //      filters = filterQuery
    //     // $(this).parents('.product-single-wrap').find('.product .grid__item').hide()
    //     // $(this).parents('.product-single-wrap').find('.coming_soon_product').show()
    // } else if (checkData == "in-stock") {
    //     productList.find(".grid__item").sort(dec_sort_title).appendTo(productList);
    // } else {

    // }

    // console.log("----",filters,checkData)
    // pagination(filters,parent);
    // page(1,parent);
  })

  
});

$(window).on('load',function(){
  if($('.qsp-related-product-list').length){
    equalheight('.qsp-related-product-list h3')
  }
})


function applyFilters(parent) {
    const productGrid = parent.find(".grid.product");
    const activeFilter = parent.find(".filter li.active").attr("data-value");
    const limitedChecked = parent.find(".grid__item .limited-button input[type='checkbox']").is(":checked");

    // Reset filters
    filters = productGrid.find(".grid__item");

    // Apply filter based on active category
    if (activeFilter === "coming-soon") {
        filters = productGrid.find(".coming_soon_product");
    } else if (activeFilter === "in-stock") {
        filters = productGrid.find(".available");
    }
    else if (activeFilter === "top-sellers") {
        filters = productGrid.find(".top-sellers");
    }

    // Apply "Limited-Time" filtering if checkbox is checked
    if (limitedChecked) {
        filters = filters.filter(".limited-time");
    }

    // Update the UI
    productGrid.find(".grid__item").hide(); // Hide all
    filters.show(); // Show only filtered items
    pagination(filters, parent);
    page(1, parent);
}

function asc_sort_title(a, b) {
    const titleA = $(a).find('.product-card__name').text().trim().toLowerCase();
    const titleB = $(b).find('.product-card__name').text().trim().toLowerCase();

    return titleA.localeCompare(titleB);
}

// decending sort
function dec_sort_title(a, b) {
    const titleA = $(a).find('.product-card__name').text().trim().toLowerCase();
    const titleB = $(b).find('.product-card__name').text().trim().toLowerCase();

    return titleB.localeCompare(titleA);
}

function asc_sort_price(a, b) {
    const priceA = parseFloat($(a).attr('data-price'));
    const priceB = parseFloat($(b).attr('data-price'));

    return priceA - priceB;
}

// decending sort
function dec_sort_price(a, b) {
    const priceA = parseFloat($(a).attr('data-price'));
    const priceB = parseFloat($(b).attr('data-price'));

    return priceB - priceA;
}

function asc_sort_date(a, b) {
     const priceA = parseFloat($(a).attr('data-date'));
    const priceB = parseFloat($(b).attr('data-date'));

    return priceA - priceB;
}

// decending sort
function dec_sort_date(a, b) {
    const priceA = parseFloat($(a).attr('data-date'));
    const priceB = parseFloat($(b).attr('data-date'));

    return priceB - priceA;
}

function sort_default(a, b) {
    const priceA = parseFloat($(a).attr('data-index'));
    const priceB = parseFloat($(b).attr('data-index'));

    return priceA - priceB;
}

// for pagination

function pagination(filterQuery, parent) {
    let innerHtml = "";
    const count = parent?.find(filterQuery)?.length; // Get item count within the scoped parent
    const totalPage = Math.ceil(count / perPage);

  console.log("====",count,totalPage)
    if (totalPage > 1) {
        innerHtml += '<li class="left-angle disabled"><img src="https://cdn.shopify.com/s/files/1/0312/2131/7764/files/aerrow-right-view.png?v=1684228967"/></li>';
        
        for (let i = 1; i <= totalPage; i++) {
            innerHtml += '<li class="number" style="display:flex;" data-page="' + i + '">' + i + '</li>';
        }
        
        innerHtml += '<li class="right-angle"><img src="https://cdn.shopify.com/s/files/1/0312/2131/7764/files/aerrow-right-view.png?v=1684228967"/></li>';
        
        parent.find('.pagination_list').html(innerHtml); // Update pagination only inside the correct parent
        
        setTimeout(function () {
            parent.find('.pagination_list li[data-page="1"]').trigger('click');
        }, 500);
    } else {
        parent?.find('.pagination_list')?.html(' '); // Clear pagination if only one page
        page(1, parent);
    }
}

function page(page_no, parent) {
    const Start = (page_no - 1) * perPage;
    const End = Start + perPage;

    parent?.find('.grid.product .grid__item')?.hide(); // Hide all items in the scoped section
    parent?.find(filters)?.slice(Start, End).show(); // Show only the required items

    window.dispatchEvent(new Event('resize'));
}


 function replaceKeywordsEverywhere(replacements) {
  // Recursive function to replace keywords in text nodes
  function replaceTextContent(node) {
    if (node.nodeType === Node.TEXT_NODE) {
      // Replace each keyword with the corresponding new keyword
      for (const [oldKeyword, newKeyword] of Object.entries(replacements)) {
        const regex = new RegExp(oldKeyword, 'gi'); // Case-insensitive global search
        node.nodeValue = node.nodeValue.replace(regex, newKeyword);
      }
    } else {
      // Traverse child nodes for replacements
      node.childNodes.forEach(replaceTextContent);
    }
  }

  // Traverse the entire DOM starting from the body
  replaceTextContent(document.body);

  // Handle dynamic content by observing DOM changes
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((addedNode) => {
        if (addedNode.nodeType === Node.TEXT_NODE) {
          replaceTextContent(addedNode);
        } else if (addedNode.nodeType === Node.ELEMENT_NODE) {
          replaceTextContent(addedNode);
        }
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
}

equalheight = function(container){

    var currentTallest = 0,
    currentRowStart = 0,
    rowDivs = new Array(),
    $el,
    topPosition = 0;
    $(container).each(function() {
    
        $el = $(this);
        $($el).height('auto')
        topPostion = $el.position().top;
        if (currentRowStart != topPostion) {
            for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
                rowDivs[currentDiv].outerHeight(currentTallest);
            }
            rowDivs.length = 0; // empty the array
            currentRowStart = topPostion;
            currentTallest = $el.outerHeight();
            rowDivs.push($el);
        } else {
            rowDivs.push($el);
            currentTallest = (currentTallest < $el.outerHeight()) ? ($el.outerHeight()) : (currentTallest);
        }
        for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
            rowDivs[currentDiv].height(currentTallest);
        }
    });
}